import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DownloadPdfService {
  constructor(private httpClient: HttpClient) {}

  downloadPDF(url: string, options?: any): void {
    const headers = new HttpHeaders({
      'Accept': 'application/pdf'
    });

    this.httpClient.get(url, { headers, responseType: 'blob' }).subscribe({
      next: (blob: Blob) => {
        // Créer le fichier PDF avec le type correct
        const file = new Blob([blob], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);
        
        // Générer un nom de fichier avec la date
        const fileName = 'rapport_transactions_' + new Date().toISOString().split('T')[0] + '.pdf';
        
        // Créer un lien temporaire pour télécharger le fichier
        const link = document.createElement('a');
        link.href = fileURL;
        link.download = fileName;
        link.style.display = 'none';
        
        // Ajouter au DOM, cliquer, puis supprimer
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        // Ouvrir également dans un nouvel onglet pour visualisation
        window.open(fileURL, '_blank');
        
        // Nettoyer l'URL après un délai
        setTimeout(() => URL.revokeObjectURL(fileURL), 60000);
      },
      error: (err) => {
        console.error('Erreur lors du téléchargement du PDF :', err);
        if (err.status === 404) {
          alert('خطأ: الملف غير موجود.');
        } else if (err.status === 500) {
          alert('خطأ: مشكلة في الخادم.');
        } else {
          alert('خطأ غير متوقع أثناء تحميل الملف.');
        }
      }
    });
  }
}